import { styled } from 'styled-components';
import { Form } from 'antd';
import Table from 'src/components/CrudCommonComponents/Table';
import Modal from 'src/components/Modal';
import LoadingOverlay from 'src/components/general-ui/LoadingOverlay';

export const EachColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .ant-form-item {
    padding-left: 16px;
    &.full-width {
      width: 100%;
    }
    &.checkbox-field {
      width: auto;
      display: flex;
      flex-direction: row;
      .ant-form-item-row {
        flex-direction: row;
      }
      .ant-form-item-control {
        width: auto;
      }
      .ant-form-item-control-input {
        min-height: auto;
      }
      .ant-form-item-control {
        display: flex;
        flex-direction: row;
        gap: 10px;
      }
    }
  }
  .timezone-id {
    margin-bottom: 4px;
    color: #698096;
  }
  .timezone-offset {
    .ant-form-item-row {
      flex-flow: row;
      .ant-form-item-label label {
        color: #698096;
      }
    }
    .ant-form-item-control-input {
      min-height: auto;
    }
    #timeZoneOffset {
      padding: 0;
      color: #698096;
    }
  }
`;
export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
`;
export const StyledModal = styled(Modal)`
  .ant-modal-body {
    position: relative;
    height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .ant-select-selector {
    height: auto !important;
  }
  .ant-select-selection-item {
    line-height: normal !important;
  }
`;
export const FormSection = styled.div`
  display: flex;
`;
export const StyledText = styled.div`
  display: flex;
  height: fit-content;
  border: 1px solid transparent;
  padding: 6px 10px;
  line-height: 1;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.06);
  display: flex;
`;
export const StyledLoader = styled(LoadingOverlay)`
  height: calc(100% - 2.4rem);
`;
export const EachRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  .criteria-selection {
    margin-top: 23px;
    min-width: 100px;
  }
`;
export const StyledTable = styled(Table)`
  .ant-table-thead > tr > .ant-table-cell {
    font-weight: 600;
    color: #252525;
    text-align: center;
  }
  .ant-table-tbody > tr > .ant-table-cell {
    padding: 0.4rem 0.8rem !important;
    text-align: center;
  }
  .ant-table-tbody > tr > .ant-table-cell > div {
    justify-content: center;
    text-align: center;
  }

  .ant-table-tbody > tr > .ant-table-cell > .list-view-percentage-cell {
    height: 1.45rem;
    line-height: 1.45rem;
  }
`;
export const Label = styled.div<{
  withUnderline?: boolean;
  withPointer?: boolean;
}>`
  font-weight: 400;
  ${props => (props.withUnderline ? 'text-decoration-line: underline;' : '')}
  ${props => (props.withPointer ? 'cursor: pointer;' : '')}
`;
